export default {
  global: {
    home: 'Home',
    login: 'Login',
    submit: 'Submit',
    reset: 'Reset',
    delete: 'Delete',
    clear: 'Clear',
    send: 'Send',
    init: 'Init',
    confirm: 'Confirm',
    min: 'Min',
    max: 'Max',
    confirmDelete: 'Are you sure you want to delete this item?',
    no_result: 'No results',
    no_select: 'No select',
    close: 'Close',
    back: 'Back',
    cancel: 'Cancel',
    update: 'Update',
    updated: 'Updated',
    updatedat: 'Updated at',
    updatedby: 'Updated by',
    view: 'View',
    viewall: 'View all',
    field: 'Field',
    value: 'Value',
    filters: 'Filter',
    data_unavailable: 'Data unavailable',
    loading: 'Loading...',
    deleted: 'Deleted',
    created: 'Created',
    createdat: 'Created at',
    createdby: 'Created by',
    uploaded: 'Uploaded',
    bigger_zero: 'Please, insert a value bigger than zero!',
    type_something: 'Please type something',
    field_required: 'Field is required',
    records_per_page: 'Records per page:',
    actions: 'Actions',
    list: 'List',
    add: 'Add',
    datestart: 'Start date',
    dateend: 'End date',
    name: 'Name',
    namefr: 'Name fr',
    fileinput: 'File input',
    credentialerror: 'Credential error',
    type: 'Type',
    date: 'Date',
    dateCreation: 'Creation date',
    dateUpdate: 'Update date',
    true: 'True',
    false: 'False',
    content: 'Content',
    access: 'Access',
    editimage: 'Edit image',
    timeline: 'Timeline',
    validate: 'Validate',
    invalidate: 'Invalidate',
    explore: 'Explore',
    addcombo1: 'Press',
    addcombo2: 'to create a new one',
    download: 'Download',
    file: 'File',
    title: 'Title',
    enable: 'Enable',
    email: 'Email',
    logo: 'Logo',
    export: 'Export',
    id: 'Id',
    maxsize: 'File too large',
    language: 'Language',
    parent: 'Parent',
    hub: 'Hub',
    default: 'Default',
    enabled: 'Enabled',
    nopicture: 'No picture',
    available: 'Available',
    number: 'N°',
    description: 'Description',
    descriptionfr: 'Description fr',
    dashboard: 'Dashboard',
    reference: 'Reference',
    uuid: 'Uuid',
    comment: 'Comment',
    version: 'Version',
    news: 'News',
    easy: 'Easy',
    normal: 'Normal',
    hard: 'Hard',
    linkshare: 'Link to share',
    pair: 'Pair',
    check: 'Check',
    savecalibration: 'Save calibration',
    controlsettings: 'Settings for Control',
    archive: 'Archive',
  },
  menu: {
    production:   'Production',
    qualitycheck:   'Quality check',
    versionning:   'Versionning',
    profile:   'Profiles',
    product:   'Product',
    administration:   'Administration',
    sav:   'S.A.V.',
    quality:   'Quality',
    documentation:   'Documentation',
    notification: {
      notifications:   'Notifications',
    },
    language: {
      english:   'English',
      french:   'French',
    },
    user: {
      profile: 'Profile',
      mybadge: 'My badges',
      badge: 'Badge',
      badgelist: 'Badge list',
      logout: 'Logout',
      notificationsubscriber: 'Notifications',
    },
  },
  app: {
    apps: 'Apps',
    app: 'App',
    url: 'Url',
    connectors: 'Connector logs',
    startconnector: 'Start connector',
  },
  service: {
    services: 'Services',
    service: 'Service',
  },
  macro: {
    macrotype: 'Macro type',
    macrotypes: 'Macro types',
    loadprocess: 'Load process',
  },
  article: {
    articles: 'Articles',
    article: 'Article',
    title: 'Title',
    titlefr: 'Title fr',
    enabled: 'Enabled',
    link: 'Link',
    linkfr: 'Link fr',
  },
  designfile: {
    designfiles: 'Library',
    designfile: '3D file',
    changeviewer: 'change the preview',
    designfiletypes: 'Types 3D file',
    designfiletype: 'Type 3D file',
    type: 'Type',
    author: 'Author',
    license: 'License',
    licensehelpchoice: 'For Lynxter 3D files, please choose the following licenses according to the types: CC BY-NC-ND 4.0 (Demonstration), CC BY-NC-SA 4.0 (Calibration), CC BY-NC-SA 4.0 (Repair)',
    description: 'Description',
    descriptionfr: 'Description fr',
  },
  process: {
    processes: 'Processes',
    process: 'Process',
    documentation: 'Tutorial',
    documentations: 'Tutorials',
    documentationsadmin: 'Tutorial search',
    documentationtype: 'Tutorial type',
    documentationtypes: 'Tutorial types',
    processesschema: 'Schema processes',
    processschema: 'Schema process',
    steps: 'Steps',
    step: 'Step',
    fields: 'Fields',
    field: 'Field',
    loadmaterial: 'Load material',
    unloadmaterial: 'Unload material',
    loadtool: 'Load tool',
    unloadtool: 'Unload tool',
    loadoption: 'Load option',
    unloadoption: 'Unload option',
    calibtool: 'Calibration tool',
    calibmachine: 'Calibration machine',
    blanking: 'Blanking',
    verification: 'Verification',
    maintenance: 'Maintenance',
    preprinting: 'Pre-printing',
    postprinting: 'Post-printing',
    time: 'Time (min)',
    intensity: 'Difficulty',
    defaultprocess: 'Default',
    tempprogress: 'See temp.',
    movementpanel: 'See movement panel',
    logpanel: 'See log panel',
    validator: 'Validator ref.',
    actionref: 'Action ref.',
    moduleref: 'Ref. module',
    subtitle: 'Video subtitle',
    subtitlefr: 'Video subtitle fr',
    linkproductcustomer: 'Product / customer links',
    defaultprocessmachine: 'Machine tutorial',
    doorOpen: 'Door open',
    withoutModuleOnly: 'Without module only',
    category: 'Category',
    fixtureRef: 'Fixture reference'
  },
  ticket: {
    ticket: 'Ticket',
    tickets: 'Tickets',
    bugtypes: 'Bug types',
    bugtype: 'Bug type',
    actiontypes: 'Action types',
    actiontype: 'Action type',
    ticketstatuses: 'Ticket statuses',
    ticketstatus: 'Ticket status',
    init: 'Init',
    hub: 'Hub',
    finish: 'Closed',
    waiting: 'In waiting',
    response: 'Response',
    process: 'To process',
    important: 'Important',
    ticketorigins: 'Ticket origins',
    ticketorigin: 'Ticket origin',
    ticketactions: 'Ticket actions',
    ticketaction: 'Ticket action',
    content: 'Content',
    timeWork: 'Work time (min)',
    resolution: 'Resolution',
    assigned: 'Assigned',
    tags: 'Tags',
    tag: 'Tag',
    statuschange: 'Status change',
    public: 'Public',
    number: 'N°',
    newrelease: 'New realease',
    datebug: 'Bug date',
    dateend: 'Closed date',
    archive: 'archive'
  },
  contact: {
    contacts: 'Contacts',
    contact: 'Contact',
    firstname: 'Firstname',
    lastname: 'Lastname',
    customer: 'Customer',
    email: 'Email',
    phone: 'Phone',
    locale: 'Locale',
    comptehub: 'Account HubCustomer',
  },
  contract: {
    contracts: 'Contracts',
    contract: 'Contract',
    contracttypes: 'Contract types',
    contracttype: 'Contract type',
    description: 'Description',
    duration: 'Duration (day)',
    timeinit: 'Init time (min)',
    timeused: 'Used time (min)',
    ref: 'Ref',
    start: 'Start',
    end: 'End',
    type: 'Type',
    customer: 'Customer',
    products: 'Products',
    comment: 'Comment',
    enable: 'Actif',
    guarantee: 'Warranty',
    maintenance: 'Maintenance',
    expired: 'expired'
  },
  profile: {
    parameter:   'Systems',
    profilefiles:   'Profile files',
    profilefile:   'Profile file',
    profilefilesutils: 'Profile file utils',
    public:   'Hub',
    experimental:   'Experimental',
    version:   'Version',
    newrelease:   'New release',
    updaterelease:   'Update release',
    customersreserved: 'Customers reserved',
    reference: 'Reference',
    description: 'Description',
    descriptionfr: 'Description fr',
    accessory: {
      accessories:   'Accessories',
      accessory:   'Accessory',
      name:   'Name',
      model:   'Model',
      version:   'Version',
    },
    option: {
      options:   'Options',
      option:   'Option',
      name:   'Name',
      model:   'Model',
      version:   'Version',
      parent:   'Option parent',
    },
    controlunit: {
      controlunits:   'Control units',
      controlunit:   'Control unit',
      name:   'Name',
      model:   'Model',
      version:   'Version',
      parent:   'Control unit parent',
    },
    industrialcomputer: {
      industrialcomputers:   'Industrial computers',
      industrialcomputer:   'Industrial computer',
      name:   'Name',
      model:   'Model',
      version:   'Version',
      parent:   'Industrial computer parent',
    },
    operatingsystem: {
      operatingsystems:   'OS',
      operatingsystem:   'OS',
      name:   'Nom',
    },
    machine: {
      machines:   'Machines',
      machine:   'Machine',
      models:   'Machine models',
      versions:   'Machine versions',
      name:   'Name',
      model:   'Model',
      parent:   'Machine parent',
      version:   'Version',
      compatiblesMachines: 'Compatibles machines',
      compatiblesToolheads: "Compatibles toolheads"
    },
    material: {
      materials:   'Materials',
      material:   'Material',
      products: 'Material products',
      product: 'Material product',
      productversions: 'Material product versions',
      productversion: 'Material product version',
      productlots: 'Material product lots',
      productlot: 'Material product lot',
      externallot: 'N° external lot',
      datemanufacture: 'Manufacture date',
      dlu: 'DLU',
      colors: 'Material colors',
      feedspecs: 'Material feed specs',
      manufacturers: 'Material manufacturers',
      mediums: 'Mediums',
      states: 'Material states',
      types: 'Material types',
      supplies: 'Material supplies',
      supply: 'Material supply',
      subsupplies: 'Sub material supplies',
      subsupply: 'Sub material supply',
      parent:   'Material supply parent',
      name:   'Name',
      shortname: 'Short name',
      namepub: 'Name pub',
      color: 'Color',
      comment: 'Comment',
      medium: 'Medium',
      feedspec: 'Feed spec.',
      manufacturer: 'Manufacturer',
      type: 'Type',
      machine: 'Machine',
      state: 'State',
      version: 'Version',
      input: 'Input',
      public: 'Public',
      description: 'Description',
      measures: 'Measures',
      tempresistance: 'Temp resistance',
      chemicalresistance: 'Chemical resistance',
      uvresistance: 'UV resistance',
      mecaresistance: 'Mechanical resistance',
      abrasionresistance: 'Abrasion resistance',
      tractionresistance: 'Traction resistance (MPa)',
      complexity: 'Complexity',
      hardness: 'Hardness (score)',
      hardnessshore: 'Hardness',
      hardnessshoretype: 'Hardness Shore type',
      elongation: 'Elongation max (%)',
      tenacity: 'Tenacity (MPa.m^1/2)',
      cost: 'Cost (€)',
      density: 'Density',
      electrical: 'Electrical',
      thermal: 'Thermal',
      dielectric: 'Dielectric',
      tempfusion: 'Fusion temp (°C)',
      graphradar: 'Radar graph',
    },
    nozzle: {
      nozzles:   'Nozzles',
      nozzle:   'Nozzle',
      nozzlesin:  'Nozzle in',
      nozzlesout:  'Nozzle out',
      nozzlein:  'Nozzle in',
      nozzleout:  'Nozzle out',
      manufacturers:  'Nozzle manufacturers',
      types:  'Nozzle types',
      materials:  'Nozzle materials',
      visuals:  'Nozzle visuals',
      name:   'Name',
      manufacturer: 'Manufacturer',
      type: 'Type',
      material: 'Material',
      visual: 'Visual',
      size: 'Size',
    },
    printingsurface: {
      printingsurfaces:   'Printing surfaces',
      printingsurface:   'Printing surface',
      materials:   'Printing surface materials',
      sizes:   'Printing surface sizes',
      thickness:   'Printing surface thickness',
      name:   'Name',
      thicknessname: 'Thickness',
      size: 'Size',
      material: 'Material',
      version: 'Version',
    },
    score: {
      scores:   'Scores',
      score:   'Score',
      benchmarks:   'Score benchmarks',
      tools:   'Score tools',
      name:   'Name',
      medium:   'Medium',
      tool:   'Tool',
      quality:   'Quality',
      benchmark:   'Benchmark',
    },
    profileparameter: {
      parameters:   'Profile parameters',
      parameter:   'Profile parameter',
      sets:   'Profile parameters set',
      set:   'Profile parameter set',
      values:   'Profile parameter values',
      name:   'Name',
      bracket: 'Bracket',
      unit: 'Unit',
      tab: 'Tab',
      section0: 'Section lvl 0',
      section1: 'Section lvl 1',
      softwareversion: 'Software',
      uuid: 'Uuid',
      setup: 'Setup',
      strategy: 'Strategy',
      date: 'Date',
      version: 'Version',
      profileparameter: 'Parameter name',
      value: 'Value'
    },
    sectionparameter: {
      sectionparameters:   'Section parameters',
      sectionparameter:   'Section parameter',
      name:   'Name',
      bracket: 'Bracket',
      software: 'Software',
    },
    strategy: {
      strategies:   'Profile strategies',
      strategy:   'Profile strategy',
      qualities:   'Profile strategy qualities',
      uuid:   'Uuid',
      software: 'Software',
      quality: 'Quality',
      part: 'Part tool',
      infill: 'Infill tool',
      densesupport: 'D. support tool',
      support: 'Support tool',
      skirt: 'Skirt tool',
      raft: 'Raft tool',
      primepillar: 'Prime pillar tool',
      oozeshield: 'Ooze shield tool',
    },
    quality: {
      qualities:   'Qualities',
      quality:   'Quality',
      focus:   'Quality focus',
      layers:   'Quality layers',
      name:   'Name',
      focusname:   'Focus',
      layer: 'Layer',
      nozzleout : 'Nozzle diameter',
      nozzlesout : 'Nozzle diameters',
      height: 'Height'
    },
    setupdefinition: {
      definitions:   'Setup definitions',
      definition:   'Setup definition',
      definitionssub:   'Setup sub definitions',
      definitionsub:   'Setup sub definition',
      uuid:   'Uuid',
      extruderquantity:   'Extruders',
      tempcontroler:   'Temp. controlers',
      machine:   'Machine',
      toolhead:   'Toolhead',
      materialsupply:   'Material supply',
      printingsurface:   'Printing surface',
      tool:   'Tool',
      material:   'Material',
      nozzle:   'Nozzle',
    },
    software: {
      softwares:   'Softwares',
      versions: 'Software versions',
      name:   'Name',
      fao:   'FAO',
      licence:   'Licence',
      software:   'Software',
      version:   'Version',
    },
    tool: {
      toolheads:   'Toolheads',
      toolhead:   'Toolhead',
      toolheadssub:   'Sub toolheads',
      toolheadsub:   'Sub toolhead',
      tools:   'Tools',
      tool:   'Tool',
      extruders:   'Extruders',
      extruder:   'Extruder',
      heaters:   'Heaters',
      heater:   'Heater',
      name:   'Name',
      comment: 'Comment',
      number: 'N°',
      toolheaddef: 'Toolhead definition',
      version:   'Version',
      machine: 'Machine',
      inputquantity: 'Input',
      outputquantity: 'Output',
      model: 'Model',
      optionsubtool: 'Option',
      materialmedium: 'Medium',
      materialfeedspec: 'Material feed spec.',
      nozzletype: 'Nozzle type',
      parent:   'Toolhead parent',
    },
  },
  version: {
    link: {
      links: 'Links',
      link: 'Link',
      name:   'Name',
      url:   'Url',
    },
    changelog: {
      changelogs: 'Change logs',
      changelog: 'Change log',
      name: 'Name',
      type: 'Type',
      typevalue: 'Value',
      start: 'Start',
      end: 'End',
      machine: 'Machine',
      toolhead: 'Toolhead',
      materialsupply: 'Material supply',
      controlunit: 'Controle unit',
      industrialcomputer: 'Industrial computer',
      printingsurface: 'Surface impression',
      operatingsystem: 'OS',
      accessory: 'Accessory',
      softwareversion: 'Software',
      newfeatures: 'New features',
      bugfixes: 'Bug fixes',
      knownbugs: 'Known bugs',
      notes: 'Notes',
      developexternal: 'External development',
      developer: 'Developer name',
    },
  },
  qualitycheck: {
    customer: {
      customers: 'Customers',
      customer: 'Customer',
      name:   'Name',
      comment:   'Comment',
      description:   'Description',
      tags:   'Tags',
      tag:   'Tag',
    },
    distributor: {
      distributors: 'Distributors',
      distributor: 'Distributor',
      name:   'Name',
      emailsupport: 'Email support',
      comment:   'Comment',
    },
    product: {
      products: 'Products customer',
      product: 'Product customer',
      production: 'Production',
      status: 'Status',
      statu: 'Status',
      name:   'Name',
      customer:   'Customer',
      customerloan:   'Customer Loan',
      softwareversion:   'Software',
      location:   'Location',
      machine: 'Machine',
      machines: 'Machines',
      toolhead: 'Toolhead',
      toolheads: 'Toolheads',
      option: 'Option',
      options: 'Options',
      materialsupply: 'Material supply',
      industrialcomputer: 'Industrial computer',
      printingsurface: 'Surface impression',
      operatingsystem: 'OS',
      controlunit: 'Control unit',
      accessory: 'Accessory',
      userassembly: 'Assembly operator',
      startassembly: 'Start assembly',
      endassembly: 'End assembly',
      delivery: 'Delivery',
      reforderfab: 'Ref. Fab. Order',
      type : 'Type',
      typevalue: 'Device',
      nbproduct: 'Quantity product',
      datas: 'Datas',
      data: 'Data',
      productparent: 'Parent product',
      productchildren: 'Children product',
      notice: 'Notice',
      updatesoft: 'Update soft',
      factoryreset: 'Factory reset',
      material: 'Matériaux',
      producttypefiles: 'Product files',
      producttypefile: 'Product file',
      producttypefiletypes: 'Product types file',
      producttypefiletype: 'Product type file',
      ipmachine: 'Ip machine',
      productcomposition: 'Composition product',
      assembly: 'Assembly',
      link: 'Tutorial link'
    },
    qualitycheck: {
      checks: 'Quality checks',
      check: 'Quality check',
      history: 'Quality checks history',
      name: 'Name',
      comment: 'Comment',
      usertesting: 'Testing operator',
      start : 'Start testing',
      end : 'End testing',
      qualitycheckvalues: 'Results',
      qualitycheckvalue: 'Result',
      product: 'Product',
      success: 'Success',
    },
    test: {
      tests: 'Tests',
      test: 'Test',
      number: 'Number',
      refexternal : 'External ref',
      name : 'Name',
      namefr : 'Name fr',
      issue : 'Issue',
      issuefr : 'Issue fr',
      comment : 'Comment',
      commentfr : 'Comment fr',
      machine : 'Machine',
      toolhead: 'Toolhead',
      materialsupply: 'Material supply',
      industrialcomputer: 'Industrial computer',
      operatingsystem: 'OS',
      controlunit: 'Control unit',
      accessory: 'Accessory',
      softwareversion: 'Software',
      option: 'Option',
      type : 'Type',
      typevalue: 'Device',
    },
    value: {
      types: 'Results type',
      type: 'Result type',
      result: 'Result',
      name : 'Name',
      originvalue : 'Origin value'
    },
  },
  priority: {
    priorities:   'Priorities',
    priority:   'Priority',
    intensity:   'Intensity',
    init:   'Init',
  },
  administration: {
    administration:   'Administration',
    securityparameter: {
      securityparameters: 'Security parameters',
      securityparameter: 'Security parameter',
      parameter: 'Parameter',
      value: 'Value',
      comment: 'Comment',
      forgot_password_time: 'Forgot password link validation time (minutes)',
      login_failure_max: 'Max number of failed login before blocking an account',
      block_password_time: 'Time (minutes) for blocking an account and Time (minutes) where the number of failed connections is counted for blocking an account',
      block_failure_allTime: 'Allows to block or not without time limit (0 to block with a time limit and 1 to block without time limit)',
      change_password_time: 'Time (days) to force password change',
      old_password_nb: 'Number of password stored to check if the new password is different from the old ones',
      password_size_min: 'Password policy, minimum password length',
      password_number_min: 'Password policy, Minimum number of digits in the password',
      password_lowercase_min: 'Password policy, Minimum number of lowercase characters in the password',
      password_uppercase_min: 'Password policy, Minimum number of uppercase characters in the password',
      password_special_min: 'Password policy, Minimum number of special characters in the password',
      logout_auto_time: 'Time (minutes) before automatic logout',
      backup_auto_time: 'Backup, time (days) between automatic backups',
      backup_server: 'Backup, ftp server address',
      backup_port: 'Backup, ftp server port',
      backup_login: 'Backup, login of the ftp server',
      backup_password: 'Backup, password of the ftp server',
      backup_folder: 'Backup, ftp server folder',
    },
    logs: 'Logs',
    backup: {
      backups: 'Saves',
      backup: 'Save',
      backupmanual: 'Save',
      confirmbackup: 'Are you sure you want to save ?',
      success: 'Success',
      address: 'Address',
      auto: 'Auto',
      size: 'Size (ko)',
      finished: 'Finished',

    },
    user: {
      users:   'Users',
      user:   'User',
      connexion: 'Connexion',
      connected: 'You are connected',
      forgotyourpassword: 'Forgot your password ?',
      passwordturnover: 'Password turnover',
      passwordturnovermessage: 'For security reasons, please change your password.',
      forgotpassword:   'Forgot password',
      forgotpasswords:   'Forgot passwords',
      forgotpasswordmessage: 'Submit a request to reset your password by email',
      initpassword:   'Init password',
      initpasswordmessage:   'Choose your new password.',
      connexionusers:   'User connexions',
      connexionuser:   'User connexion',
      ipadress: 'IP Adress',
      login: 'Login',
      password: 'Password',
      oldpassword: 'Old password',
      plainPassword: 'New password',
      confirmPassword: 'Confirm password',
      sameAsPassword: 'Password confirmation is different from password',
      connexionBtn: 'Connexion',
      updatemypassword: 'Update my password',
      email: 'Email',
      date: 'Date',
      failed: 'Connexion failed',
      name: 'Name',
      surname: 'Surname',
      firstname: 'Firstname',
      lastname: 'Lastname',
      enabled: 'Enabled',
      blocked: 'Blocked',
      supervision: 'Supervision',
      create: 'Create',
      lastlogin: 'Last login',
      passwordrequestedat: 'Last forgot password',
      dateblock: 'Last blocking of the account',
      myprofile:  'My profile',
      createconfirm: 'The user has been successfully registered.',
      passwordtemp: 'Temporary password to send to the user',
      unblockuser: 'Unblock user',
      initpassworduser: 'Init password for user',
      initpasswordconfirm: 'The user password reset has been saved.',
    },
    profil: {
      profil:   'Profil',
      profils:   'Profils',
      profilinterface:   'Interface Profil',
      profilinterfaces:   'Profils interface',
      base:   'Default',
      blocs:   'Blocs',
    },
    access: {
      access_read:   'Access - read',
      connexion_user_read:   'User connexions - read',
      forgot_password_read:   'Forgot passwords - read',
      profil_read:   'Profil - read',
      profil_edit:   'Profil - edit',
      security_parameter_read:   'Security parameter - read',
      security_parameter_edit:   'Security parameter - edit',
      user_read:   'User - read',
      user_edit:   'User - edit',
      user_password_init:   'Init password',
      user_unblock:   'User unblock',
    },
    notification: {
      notification:   'Notification',
      notifications:   'Notifications',
      viewall: 'Mark as read all',
      view: 'Mark as read',
      noview: 'Mark as unread',
    },
  },
  notification: {
    security: {
      newuser:   'A new user has been added : {0}',
      newprofil:   'A new profil has been added : {0}',
    },
    product: {
      newmachine:   'A new machine has been added : {0}',
      newtoolhead:   'A new toolhead has been added : {0}',
      newmaterialsupply: 'A new meterial supply has been added : {0}',
      newindustrialcomputer: 'A new industrial computer has been added : {0}',
      newcontrolunit: 'A new control unit has been added : {0}',
      newaccessory: 'A new accessory has been added : {0}',
      newoption: 'A new option has been added : {0}',
      delivery: 'The delivery of the {0} product has been changed to : {2}',
      changelog: 'A new change log has been added : {0}',
      newsoftwareVersion: 'A new software has been added : {0}',
      newprintingsurface: 'A new printing surface has been added : {0}',
      newoperatingsystem: 'A new OS has been added : {0}',
    },
    ticket: {
      assignedticket:   'You have a new ticket assigned : {0}',
      newticket:   'A new ticket has been added : {0}',
      updateticket: 'A ticket {0} has been updated',
    },
  },
};
